<script>
  import { t } from 'svelte-i18n';
  import ModalSection from './modal-section.svelte';
    import Footer from './footer.svelte';
</script>

<ModalSection first="true" desktopImg="true">
  <div slot="text">
    <h1 class="pb-0 text-md-integrations-primary">{$t('WORK.MDINTEGRATIONS.TITLE')}</h1>
    <h1 class="pt-0">{$t('MODAL.MDINTEGRATIONS.TITLE')}</h1>
  </div>
  <p class="text-opaque-black" slot="padding">
    {$t('MODAL.MDINTEGRATIONS.DESCRIPTION')}
  </p>
  <div
    slot="img"
    style="background-image: url('images/md-integrations-img-1.png'); background-position: top left;"
    class="bg-right bg-cover bg-no-repeat w-full sm:min-w-[486px] min-h-full h-auto ml-14 sm:ml-[4.5rem] md:ml-[8rem] md2:ml-0"
  />
</ModalSection>

<ModalSection app="md-integrations" bgDark="true" inverse="true">
  <div slot="text" class="">
    <h1 class="text-white selection:bg-white selection:text-black">
      {$t('MODAL.MDINTEGRATIONS.TITLE2')}
    </h1>
    <p class="text-md-integrations-gray selection:bg-white selection:text-black">
      {@html $t('MODAL.MDINTEGRATIONS.DESCRIPTION2')}
    </p>
  </div>
  <img
    slot="img"
    alt="md integrations screen on a mobile device"
    src="images/md-integrations-img-2.png"
    class="img-mob md2:max-w-[420px] h-auto"
  />
</ModalSection>

<ModalSection centeredImg="true">
  <div slot="text">
    <h1>{$t('MODAL.MDINTEGRATIONS.TITLE3')}</h1>
    <p class="text-opaque-black">
      {@html $t('MODAL.MDINTEGRATIONS.DESCRIPTION3')}
    </p>
  </div>
  <img
    slot="img"
    alt="md integrations encounter screen on a browser view"
    src="images/md-integrations-img-3.png"
    class="img-desk"
  />
</ModalSection>
<Footer />

<style>
  p {
    @apply py-0;
  }
  .img-mob {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.35));
  }
  .img-desk {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.15));
  }
</style>
